import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { components } from '@atlaskit/select';

/**
 * This creates a functional component that `react-select` will use to make the
 * SingleValue part of the different pickers.
 */
export var makeSingleValue = function makeSingleValue(_ref) {
  var lang = _ref.lang;
  return function (_ref2) {
    var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(components.SingleValue, _extends({}, props, {
      innerProps: {
        lang: lang
      }
    }), children);
  };
};